import { useState, useEffect } from 'react';

const useLocalStorage = (key, defaultValue = '') => {
  const [state, setState] = useState(
    () => window.localStorage.getItem(key) || defaultValue
  );

  useEffect(() => {
    window.localStorage.setItem(key, state);
  }, [state, setState, key]);

  return [state, setState];
};

export default useLocalStorage;
